import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Loader2 } from 'lucide-react';
import { z } from 'zod';

import { useIsStudioV2 } from '~entities/studios/hooks/use-is-studio-v2';

import { RedirectFamilyToHub } from '~features/family-hub/ui/redirect-family-to-hub';
import { StudentByFamilyListPage } from '~features/students/ui/student-by-family-list-page';

const Component = () => {
  const { parentId } = Route.useSearch();
  const { isV2, isLoading } = useIsStudioV2();

  if (isLoading) {
    return (
      <div className='flex min-h-[40vh] items-center justify-center gap-2 p-8 text-sm text-muted-foreground'>
        <Loader2 className='size-4 animate-spin' />
        Loading…
      </div>
    );
  }

  if (isV2) {
    return <RedirectFamilyToHub parentId={parentId} />;
  }

  return <StudentByFamilyListPage parentId={parentId} />;
};

const searchSchema = z.object({
  parentId: z.string(),
});

export const Route = createFileRoute('/_auth/family')({
  component: Component,
  validateSearch: zodValidator(searchSchema),
});
